import { Helmet } from "react-helmet-async";
import { Footer } from "../home/components/Footer";
import { Navbar } from "../home/components/Navbar";
import BlogList from "./components/BlogList";
import "./index.css";

function BlogPage() {
  return (
    <>
      <Helmet>
        <title>QRBite Blog - Recent Posts</title>
        <meta
          content="Read our latest blog posts on various topics."
          name="description"
        />
        <meta content="blog, articles, posts" name="keywords" />
        <meta content="Blog - Recent Posts" property="og:title" />
        <meta
          content="Read our latest blog posts on various topics."
          property="og:description"
        />
        <meta content="website" property="og:type" />
        <meta content={window.location.href} property="og:url" />
        {/* <meta content="/path/to/default-image.jpg" property="og:image" /> */}
        <link href={window.location.href} rel="canonical" />
      </Helmet>

      <Navbar />
      <BlogList />
      <Footer />
    </>
  );
}

export default BlogPage;
